import { TableCell, TableHead, TableRow } from '@mui/material';

const ContentTableHead = () => {
  const headTitles = ['Title', 'Author', 'Status', 'Created'];
  return (
    <TableHead>
      <TableRow>
        {headTitles.map((name: string, idx: number) => (
          <TableCell
            key={`head-${name}-${idx}`}
            align={idx === 0 ? 'left' : 'right'}
          >
            {name}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default ContentTableHead;
